import React from "react";
import dayjs from "dayjs";
import { IconButton } from "@mui/material";

import { formatNumber } from "../../../../utils/utils";
import { EXPENSE_TYPE_OPTIONS } from "../material.utils";
import { Delete } from "../../../../utils/svg-components";
import SelectField from "../../../../components/form-fields/select-field/select-field";
import DateTimePickerField from "../../../../components/form-fields/date-picker/date-picker";
import TextInputField from "../../../../components/form-fields/text-input-field/text-input-field";
import { DollarIcon, PercentageIcon } from "../../../../utils/svg-components";

const MaterialRow = ({
  task,
  taskIndex,
  materialIndex,
  onTaskChange,
  onDelete,
  isGeneralUser,
}) => {
  const handleChange = (field, value) =>
    onTaskChange(materialIndex, taskIndex, field, value);
  return (
    <div className="material-task">
      <div className="material-1">
        <div className="row1-delete">
          {!isGeneralUser && (
            <IconButton
              className="delete"
              onClick={() => onDelete(materialIndex, taskIndex)}
            >
              <Delete />
            </IconButton>
          )}
        </div>
        <div className="row1-content">
          <TextInputField
            isRequired
            disabled={isGeneralUser}
            value={task.description}
            label="Material Description"
            onChange={(e) => handleChange("description", e.target.value)}
          />
          <SelectField
            isRequired
            label="Expense Type"
            value={task.expenseType}
            disabled={isGeneralUser}
            placeholder="Material Type of Expense"
            options={EXPENSE_TYPE_OPTIONS}
            onChange={(e) => handleChange("expenseType", e.target.value)}
          />
        </div>
      </div>
      <div className="material-2">
        <div className="left">
          <DateTimePickerField
            label="Incurred Date"
            value={
              task.incurredDate ? dayjs(task.incurredDate, "YYYY-MM-DD") : null
            }
            placeholder={"mm-dd-yy"}
            disabled={isGeneralUser}
            onChange={(e) => {
              const date = e ? dayjs(e).format("YYYY-MM-DD") : null;
              handleChange("incurredDate", date);
            }}
          />
          <TextInputField
            isRequired
            value={task.quantity}
            inputType="number"
            placeholder="QTY"
            label="Quantity"
            disabled={isGeneralUser}
            onChange={(e) => handleChange("quantity", e.target.value)}
          />

          <TextInputField
            isRequired
            value={task.cost}
            inputType="number"
            placeholder="Cost"
            label="Cost"
            InputProps={{ startAdornment: <DollarIcon /> }}
            disabled={isGeneralUser}
            onChange={(e) => handleChange("cost", e.target.value)}
          />
          <TextInputField
            value={task.markup}
            inputType="number"
            placeholder="Markup"
            label="Markup"
            InputProps={{ endAdornment: <PercentageIcon /> }}
            disabled={isGeneralUser}
            onChange={(e) => handleChange("markup", e.target.value)}
            required={task.isRequired}
          />
        </div>
        <TextInputField
          value={formatNumber(task.total)}
          placeholder="Total"
          label="Total"
          InputProps={{ startAdornment: <DollarIcon /> }}
          disabled={isGeneralUser}
          className="totalInput"
          sx={{ pointerEvents: "none" }}
        />
      </div>
    </div>
  );
};

export default MaterialRow;
